/* eslint-disable import/extensions */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
	Col,
	Row,
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	FormGroup,
	Label,
	ModalFooter,
	Input,
} from 'reactstrap';
import * as acessos from '../../../acessos.const.util';
import { acessoPermitido } from '../../../acessos.seguranca';
import './styles.css';
import IntlMessage from '../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

function ConfirmacaoSelect({
	isOpen,
	toggle,
	title,
	shoModalJustificativa,
	confirmTextLabel,
	etapaSelecionada,
	setEtapaSelecionada,
}) {
	const usuario = useSelector((state) => state.usuario);
	const detalhes = useSelector((state) => state.commonReducer.detalhes);
	const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}

	const [etapasRealizadas, setEtapasRealizadas] = useState([]);
	const [etapasParaCancelamento, setEtapasParaCancelamento] = useState([]);
	const [etapasRestantes, setEtapasRestantes] = useState([]);
	const [etapasNaoPermitidas, setEtapasNaoPermitidas] = useState([]);

	useEffect(() => {
	    let _etapasRestantes = detalhes.etapas;
		if(detalhes.isLaudoLiberado) {
			const liberado = {
				"etapa": "LIBERADO",
				"status": "realizado",
				"dataEtapa": detalhes.dataLiberacao,
				"etapaFinalizada": true
			}
			_etapasRestantes.push(liberado);
		}

		setEtapasRealizadas(_etapasRestantes.filter(
			(etapa) => etapa.status === 'realizado' || etapa.status === 'conferencia' || etapa.status === 'pendente' || etapa.status === 'revisao'
		))
	}, [])

	useEffect(() => {
		if (etapasRealizadas.length > 0) {
			setEtapaSelecionada(etapasRealizadas && etapasRealizadas[0].etapa)
		}
		selectionarEtapasRealizadas(usuario);
	}, [etapasRealizadas])

	useEffect(() => {
		const indexEtapaSelecionada = etapasRealizadas.findIndex(
			(etapa) => etapa.etapa === etapaSelecionada
		);

		const etapas = etapasRealizadas.map((etapa) => etapa.etapa);
		let _etapasRestantes = etapas.slice(0, indexEtapaSelecionada);
		/* _etapasRestantes = detalhes.isLaudoLiberado ? _etapasRestantes */
		setEtapasParaCancelamento(etapas.slice(indexEtapaSelecionada));
		setEtapasRestantes(_etapasRestantes);
	}, [etapaSelecionada]);

	const selectionarEtapasRealizadas = (usuario) => {
		etapasRealizadas.map((verificarPermissaoEtapas, index) => {
			switch (verificarPermissaoEtapas.etapa) {
				case 'MATERIAL':
					if (!acessoPermitido(usuario, acessos.CancelamentoMATERIAL)) definirEtapas(index)
					break;

				case 'MACRO':
					if (!acessoPermitido(usuario, acessos.CancelamentoMacro)) definirEtapas(index)
					break;

				case 'MICRO':
					if (!acessoPermitido(usuario, acessos.CancelamentoMicro)) definirEtapas(index)
					break;

				case 'HISTO':
					if (!acessoPermitido(usuario, acessos.CancelamentoHisto)) definirEtapas(index)
					break;

				case 'IMUNO':
					if (!acessoPermitido(usuario, acessos.CancelamentoImuno)) definirEtapas(index)
					break;

				case 'FISH':
					if (!acessoPermitido(usuario, acessos.CancelamentoFish)) definirEtapas(index)
					break;

				case 'CISH':
					if (!acessoPermitido(usuario, acessos.CancelamentoCish)) definirEtapas(index)
					break;

				case 'PCR':
					if (!acessoPermitido(usuario, acessos.CancelamentoPcr)) definirEtapas(index)
					break;

				case 'CONGELACAO':
					if (!acessoPermitido(usuario, acessos.CancelamentoCongelacao)) definirEtapas(index)
					break;

				case 'NOTAS':
					if (!acessoPermitido(usuario, acessos.CancelamentoNotas)) definirEtapas(index)
					break;

				case 'CONCLUSAO':
					if (!acessoPermitido(usuario, acessos.CancelamentoConclusao)) definirEtapas(index)
					break;

				case 'ERRATA':
					if (!acessoPermitido(usuario, acessos.CancelamentoErrata)) definirEtapas(index)
					break;

				default:
					break;
			}
		})
	}

	function definirEtapas(index) {
		const etapasBloqueadas = etapasRealizadas.filter((etapa, indexAtual) => indexAtual <= index)
		const etapasPermitidas = etapasRealizadas.filter((etapa, indexAtual) => indexAtual > index)
		setEtapasNaoPermitidas([...etapasBloqueadas]);
		setEtapasRealizadas([...etapasPermitidas])
	}

	return (
		<Modal isOpen={isOpen} toggle={toggle}>
			<ModalHeader toggle={toggle}>
				{title || <IntlMessage id = "dashboards.examDetail.cancelStep.confirm"/>}
			</ModalHeader>
			<ModalBody>
				<Row>
					<Col>
						<FormGroup className="justificativa-cancelar">
							<Label>
								<IntlMessage id = "dashboards.examDetail.cancelStep.confirmCancel"/>
							</Label>
							<Input
								type="select"
								placeholder={translate("dashboards.examDetail.cancelStep.selectStep")}
								value={etapaSelecionada}
								onChange={(e) => setEtapaSelecionada(e.target.value)}
							>
								{etapasRealizadas.map((e) => (
									<option key={e.etapa} value={e.etapa}>
										{e.etapa}
									</option>
								))}
							</Input>
							<div className="relacao-etapas">
								<ul>
									{etapasRestantes.map((etapaQuePermanecem, index) => (
										<li key={index}>
											<strong className="restantes">
												{etapaQuePermanecem}
											</strong>
										</li>
									))}
									{etapasParaCancelamento.map((etapaParaCancelar, index) => (
										<li key={index}>
											<strong className="cancelar">{etapaParaCancelar}</strong>
										</li>
									))}
									{etapasNaoPermitidas.map((etapaNaoPermitada, index) => (
										<li key={index}>
											<strong className="nao-permitido">{etapaNaoPermitada.etapa}</strong>
										</li>
									))}
								</ul>
							</div>
						</FormGroup>

						<div className="legendas">
							<span><IntlMessage id = "dashboards.examDetail.cancelStep.legends"/></span>
							<div className="permanecer">
								<div className="bloco" />
								<span><IntlMessage id = "dashboards.examDetail.cancelStep.stepsCompleted"/></span>
							</div>
							<div className="cancelar">
								<div className="bloco" />
								<span><IntlMessage id = "dashboards.examDetail.cancelStep.stepsCanceled"/></span>
							</div>
							<div className="nao-permitido">
								<div className="bloco" />
								<span><IntlMessage id = "dashboards.examDetail.cancelStep.stepsNotAllowed"/></span>
							</div>
						</div>
					</Col>
				</Row>
			</ModalBody>
			<ModalFooter>
				<Button onClick={toggle} color="secondary">
					<IntlMessage id = "dashboards.examDetails.cancel"/>
				</Button>
				<Button onClick={shoModalJustificativa} color="primary">
					{confirmTextLabel || <IntlMessage id = "dashboards.examDetail.cancelStep.stepCancel"/>}
				</Button>
			</ModalFooter>
		</Modal>
	);
}

export default ConfirmacaoSelect;



// WEBPACK FOOTER //
// ./src/componentes/cancelamento/ConfirmacaoSelect/index.jsx